<template>
    <div>
        <i class="fa fa-fw text-left fa-btn fa-cog pointer" :id="tableConfigurationId" tabindex="0"></i>
        <b-popover :target="tableConfigurationId" placement="bottomleft" triggers="focus">
            <form>
                <div class="d-flex flex-column justify-content-center pb-2">
                    <a @click="saveColumns" class="btn btn-primary btn-sm btn-block">Save</a>
                </div>
                <Container @drop="onDrop" drag-class="opacity-ghost" drop-class="opacity-ghost-drop" :get-ghost-parent="getGhostParent">
                    <Draggable v-for="column in columns" :key="column.id">
                        <div class="draggable-item">
                            <i class="fa fa-align-justify handle pr-1"></i>
                            <b-form-checkbox v-model="column.checked"></b-form-checkbox>
                            {{ getColumnFieldPropertyName(column.name) }}
                        </div>
                    </Draggable>
                </Container>
                <div class="d-flex flex-column justify-content-center pt-2">
                    <a @click="saveColumns" class="btn btn-primary btn-sm btn-block">Save</a>
                </div>
            </form>
        </b-popover>
    </div>
</template>

<script>
import { Container, Draggable } from "vue-smooth-dnd";

export default {
    props: ['name' , 'projects', 'current-order', 'state', 'masks', 'filter', 'user', 'fixedDateRangeIdentifier', 'userIds', 'officeIds', 'contractTypeIds','fieldLabels',
        'recordDetailFieldLabels'],
    data() {
        return {
            drag: false,
            columns: this.state[this.name],
        };
    },
    methods: {
        saveColumns() {
            window.location.reload()
        },
        saveState() {
            let newState = this.state;
            newState[this.name] = this.columns;
            this.$emit('stateUpdated', newState);
        },

        getGhostParent() {
            return document.body;
        },
        onDrop(dropResult) {
            const { removedIndex, addedIndex, payload } = dropResult
            if (removedIndex === null && addedIndex === null) return this.columns

            const result = [...this.columns]
            let itemToAdd = payload

            if (removedIndex !== null) {
                itemToAdd = result.splice(removedIndex, 1)[0]
            }

            if (addedIndex !== null) {
                result.splice(addedIndex, 0, itemToAdd)
            }
            this.columns = result;
            this.saveState();
        },
        getColumnFieldPropertyName(columnName) {
            const finalLabels = this.recordDetailColumnsList.includes(columnName.replace(/ /g, '-').toLowerCase()) ? this.recordDetailFieldLabels : this.fieldLabels;
            return this.getFieldLabel(finalLabels, columnName.replace(/ /g, '-').toLowerCase());
        }
    },
    components: { Container, Draggable },
    computed: {
        tableConfigurationId() {
            return 'table-configuration-' + this.name;
        }
    },
    watch: {
        'name': function (value, oldValue) {
            if(value) {
                this.columns = this.state[value];
                this.saveState();
            }
        },
        columns: {
            handler: function (val, oldVal) {
                this.saveState();
            },
            deep: true
        }
    },
    created() {
        this.saveState();
    }
}
</script>

<style lang="scss">
.bg-qualified{
    background-color: #00ff8f;
}
tr td:nth-child(2), tr th:nth-child(2) {
    padding-left: .5rem;
}
.pointer {
    cursor: pointer;
}
.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.popover-body {
    height: 300px;
    overflow-y: auto;
}

.draggable-item {
    border: 1px solid rgba(0, 0, 0, .125);
    margin: 2px 0px;
    padding: 5px;
    cursor: move;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: flex;
    align-items: center;
}

.draggable-item .custom-control{
    margin-left: 10px !important;
}

.dragging {
    background-color: yellow;
}


.opacity-ghost {
    transition: all .18s ease;
    opacity: 0.8;
    /* transform: rotateZ(5deg); */
    background-color: cornflowerblue;
    box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.3);
}

.opacity-ghost-drop {
    opacity: 1;
    /* transform: rotateZ(0deg); */
    background-color: white;
    box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.0);
}
.cards-drop-preview {
    background-color: rgba(150, 150, 200, 0.1);
    border: 1px dashed #abc;
    margin: 5px 45px 5px 5px;
}
.smooth-dnd-ghost{
    z-index: 1100 !important;
}
</style>
